module.exports = __webpack_public_path__ + "favicon-32x32.png?8ae55f21ac79f3642360a296f5b7bfd2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicons/favicon-32x32.png
// module id = 24
// module chunks = 0